(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[716],{

/***/ 636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrowDownBlue(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 6.323,
    viewBox: "0 0 10.5 6.323"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M5.271 3.848L8.631.587a.97.97 0 011.338 0 .9.9 0 010 1.308L5.945 5.801a.97.97 0 01-1.348 0L.525 1.895a.915.915 0 010-1.308.97.97 0 011.338 0z",
    fill: "#194dff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowDownBlue);

/***/ }),

/***/ 89905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrowRightWhite(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 15.98 16"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.88 7.493a1.332 1.332 0 00-.28-.44L8.939.392a1.338 1.338 0 00-1.892 1.892l4.4 4.383H1.332a1.332 1.332 0 000 2.664h10.112l-4.4 4.383a1.338 1.338 0 101.895 1.89L15.6 8.945a1.377 1.377 0 00.28-1.452z",
    fill: "#fff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRightWhite);

/***/ }),

/***/ 60716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ careers_Careers; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/common/page-meta-tags/PageMetaTags.tsx
var PageMetaTags = __webpack_require__(96696);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ./components/careers/welcome/Welcome.module.scss
var Welcome_module = __webpack_require__(69984);
var Welcome_module_default = /*#__PURE__*/__webpack_require__.n(Welcome_module);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ../core/dist/components/app-btn/AppBtn.js + 2 modules
var AppBtn = __webpack_require__(49995);
// EXTERNAL MODULE: ../core/dist/icons/arrow-right-white.svg
var arrow_right_white = __webpack_require__(89905);
;// CONCATENATED MODULE: ./components/careers/welcome/Welcome.tsx









var ScrollLink = modules/* default.Link */.ZP.Link;
var Welcome = function() {
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Welcome_module_default()).row),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Welcome_module_default()).textCol,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                children: [
                                    "Join us and build the largest",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "data-hover": "B2B Transport Marketplace",
                                        className: isMobile ? "" : "indaiText",
                                        children: "B2B Transport Marketplace"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollLink, {
                                to: "jobs",
                                spy: true,
                                smooth: true,
                                duration: 0,
                                activeClass: "active",
                                // offset={-getHeightByViewPort(74).slice(0, -2)}
                                offset: -"74px".slice(0, -2),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBtn/* default */.Z, {
                                    className: (Welcome_module_default()).openPositionBtn,
                                    children: [
                                        "Open Positions ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_white/* default */.Z, {})
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Welcome_module_default()).imgCol,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Welcome_module_default()).imgboxRow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Welcome_module_default()).imgbox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                        src: "offsite-image-banner-2.jpg",
                                        placeholder: "empty",
                                        alt: "Vahak-Jobs",
                                        layout: "responsive",
                                        width: isMobile ? "106" : "178",
                                        height: isMobile ? "160" : "268",
                                        priority: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Welcome_module_default()).imgbox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                        src: "offsite-image-banner-1.jpg",
                                        placeholder: "empty",
                                        alt: "Vahak-Careers",
                                        layout: "responsive",
                                        width: isMobile ? "205" : "346",
                                        height: isMobile ? "136" : "232",
                                        priority: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Welcome_module_default()).imgbox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                        src: "offsite-image-banner-3.jpg",
                                        placeholder: "empty",
                                        alt: "Vahak-Jobs",
                                        layout: "responsive",
                                        width: isMobile ? "160" : "271",
                                        height: isMobile ? "106" : "180",
                                        priority: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Welcome_module_default()).imgbox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                        src: "offsite-image-banner-4.jpg",
                                        placeholder: "empty",
                                        alt: "Vahak-Careers",
                                        layout: "responsive",
                                        width: isMobile ? "142" : "239",
                                        height: isMobile ? "140" : "255",
                                        priority: true
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Welcome_module_default()).ourVision),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        children: [
                            "What drives our ",
                            "",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                "data-hover": "Vision",
                                className: isMobile ? "" : "indaiText",
                                children: "Vision"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "At Vahak, we are on a mission to democratize B2B road transportation for all. We aim to build the largest and most trusted transport marketplace. In an ecosystem where load owners with plenty of requirements struggle to find lorries and truck owners are seldom able to find loads, we want to bridge this gap."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Our goal is to make Vahak India’s go-to-platform for all road transportation and logistics requirements. We’re not just building an app, we’re building a community that’s uniting lakhs of Indian transporters!"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var welcome_Welcome = (Welcome);

// EXTERNAL MODULE: ./components/careers/our-values/OurValues.module.scss
var OurValues_module = __webpack_require__(56706);
var OurValues_module_default = /*#__PURE__*/__webpack_require__.n(OurValues_module);
// EXTERNAL MODULE: ../core/dist/components/responsive-container/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(53679);
;// CONCATENATED MODULE: ./components/careers/our-values/OurValues.tsx





var OurValues = function() {
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (OurValues_module_default()).ourValuesHeading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    children: [
                        "We are equal parts",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "data-hover": "fun and responsible!",
                            className: isMobile ? "" : "indaiText",
                            children: "fun and responsible!"
                        }),
                        " ",
                        "At Vahak, all our people believe in"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (OurValues_module_default()).valuesRow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveContainer/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (OurValues_module_default()).valuesCard,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (OurValues_module_default()).textBox,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Taking Ownership"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Everyone owns the product and the dream!"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (OurValues_module_default()).valuesCard,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (OurValues_module_default()).textBox,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Collaborating on the job"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Our Team works hand-in-hand"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (OurValues_module_default()).valuesCard,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (OurValues_module_default()).textBox,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Striving for Excellence"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "We want to make our product the best."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (OurValues_module_default()).valuesCard,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (OurValues_module_default()).textBox,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Thinking User-first"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Our decisions are always user-first"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (OurValues_module_default()).valuesCard,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (OurValues_module_default()).textBox,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Learning on-the-go"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "We invest in our people and pride ourselves in their growth!"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var our_values_OurValues = (OurValues);

// EXTERNAL MODULE: ./components/careers/benefits/Benefits.tsx + 6 modules
var Benefits = __webpack_require__(73763);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./components/careers/lifeat-vahak/LifeatVahak.module.scss
var LifeatVahak_module = __webpack_require__(22010);
var LifeatVahak_module_default = /*#__PURE__*/__webpack_require__.n(LifeatVahak_module);
// EXTERNAL MODULE: ../core/dist/components/scrollable-container/ScrollableContainer.js + 2 modules
var ScrollableContainer = __webpack_require__(12658);
// EXTERNAL MODULE: ./components/careers/lifeat-vahak/lifeat-vahak-image/LifeatVahakImage.module.scss
var LifeatVahakImage_module = __webpack_require__(2060);
var LifeatVahakImage_module_default = /*#__PURE__*/__webpack_require__.n(LifeatVahakImage_module);
;// CONCATENATED MODULE: ./components/careers/lifeat-vahak/lifeat-vahak-image/LifeatVahakImage.tsx





var LifeatVahakImage = function(param) {
    var lifeatVahakImg = param.lifeatVahakImg;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LifeatVahakImage_module_default()).slideItem,
        style: {
            width: isMobile ? "".concat(lifeatVahakImg.widthSmall, "px") : "".concat(lifeatVahakImg.widthLarge, "px"),
            height: isMobile ? "200px" : "250px",
            margin: "6px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
            src: "".concat(lifeatVahakImg.imageurlLarge),
            alt: lifeatVahakImg.title,
            layout: "responsive",
            width: isMobile ? "".concat(lifeatVahakImg.widthSmall) : "".concat(lifeatVahakImg.widthLarge),
            height: isMobile ? "197" : "249"
        })
    });
};
/* harmony default export */ var lifeat_vahak_image_LifeatVahakImage = (LifeatVahakImage);

;// CONCATENATED MODULE: ./components/careers/lifeat-vahak/LifeatVahak.tsx






// import "./LifeatVahak.scss";

var vahakLifeImages = [
    {
        id: 1,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: "group_20-desktop.png",
        title: "vahak-team-party-20"
    },
    {
        id: 2,
        widthLarge: 195,
        widthSmall: 154,
        imageurlLarge: "akshay_10-desktop.png",
        title: "Akshay"
    },
    {
        id: 3,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: "anshul_10-desktop.png",
        title: "Anshul"
    },
    {
        id: 6,
        widthLarge: 526,
        widthSmall: 416,
        imageurlLarge: "group_11-desktop.png",
        title: "vahak-team-party-11"
    },
    {
        id: 4,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: "atul_10-desktop.png",
        title: "Atul"
    },
    {
        id: 5,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: "group_10-desktop.png",
        title: "vahak-team-party-10"
    },
    {
        id: 7,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: "group_12-desktop.png",
        title: "vahak-team-party-12"
    },
    {
        id: 8,
        widthLarge: 443,
        widthSmall: 350,
        imageurlLarge: "group_19-desktop.png",
        title: "vahak-team-party-19"
    },
    {
        id: 10,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: "group_18-desktop.png",
        title: "vahak-team-party-18"
    },
    {
        id: 11,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: "group_13-desktop.png",
        title: "vahak-team-party-13"
    },
    {
        id: 11,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: "krishna_01-desktop.png",
        title: "Krishna"
    },
    {
        id: 9,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: "hiraj_10.png",
        title: "Hiraj Dey"
    },
    {
        id: 12,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: "group_14-desktop.png",
        title: "vahak-team-party-14"
    },
    {
        id: 13,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: "group_15-desktop.png",
        title: "vahak-team-party-15"
    },
    {
        id: 15,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: "group_17-desktop.png",
        title: "vahak-team-party-17"
    },
    {
        id: 14,
        widthLarge: 526,
        widthSmall: 416,
        imageurlLarge: "group_16-dektop.png",
        title: "vahak-team-party-16"
    },
    {
        id: 16,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: "group_21-desktop.png",
        title: "vahak-team-party-21"
    },
    {
        id: 18,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: "karrup_01-desktop.png",
        title: "Karrup"
    },
    {
        id: 19,
        widthLarge: 172,
        widthSmall: 136,
        imageurlLarge: "sharin_10-desktop.png",
        title: "Sharin"
    },
    {
        id: 17,
        widthLarge: 118,
        widthSmall: 93,
        imageurlLarge: "group_21-desktop.png",
        title: "vahak-team-party-22"
    },
    {
        id: 20,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: "tanu_10-desktop.png",
        title: "Tanushree"
    },
    {
        id: 21,
        widthLarge: 103,
        widthSmall: 82,
        imageurlLarge: "vidya_10-desktop.png",
        title: "Vidya"
    },
    {
        id: 22,
        widthLarge: 444,
        widthSmall: 351,
        imageurlLarge: "rohit_10-desktop.png",
        title: "Rohit"
    },
    {
        id: 24,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: "group_01-desktop.png",
        title: "vahak-team-party-01"
    },
    {
        id: 23,
        widthLarge: 249,
        widthSmall: 197,
        imageurlLarge: "avadhesh_web_pic-desktop.png",
        title: "Avadhesh Maurya"
    },
    {
        id: 25,
        widthLarge: 249,
        widthSmall: 197,
        imageurlLarge: "neel_01-desktop.png",
        title: "Indraneel Dutta"
    },
    {
        id: 26,
        widthLarge: 263,
        widthSmall: 208,
        imageurlLarge: "suresh_01-desktop.png",
        title: "Suresh"
    },
    {
        id: 29,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: "group_05-desktop.png",
        title: "vahak-team-party-05"
    },
    {
        id: 27,
        widthLarge: 244,
        widthSmall: 197,
        imageurlLarge: "shrey_01-desktop.png",
        title: "Shrey"
    },
    {
        id: 28,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: "karrup_01-desktop.png",
        title: "Karrup"
    },
    {
        id: 32,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: "group_03-desktop.png",
        title: "vahak-team-party-03"
    },
    {
        id: 30,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: "group_04-desktop.png",
        title: "vahak-team-party-04"
    },
    {
        id: 33,
        widthLarge: 260,
        widthSmall: 206,
        imageurlLarge: "ali_01-desktop.png",
        title: "Ali"
    },
    {
        id: 34,
        widthLarge: 187,
        widthSmall: 148,
        imageurlLarge: "group_06-desktop.png",
        title: "vahak-team-party-06"
    },
    {
        id: 35,
        widthLarge: 249,
        widthSmall: 197,
        imageurlLarge: "chintan_01-desktop.png",
        title: "Chintan"
    },
    {
        id: 31,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: "group_02-desktop.png",
        title: "vahak-team-party-02"
    },
    {
        id: 32,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: "offsite-image-5.jpg",
        title: "vahak-offsite"
    },
    {
        id: 33,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: "offsite-image-1.jpg",
        title: "vahak-offsite"
    },
    {
        id: 34,
        widthLarge: 500,
        widthSmall: 263,
        imageurlLarge: "offsite-image-2.jpg",
        title: "vahak-offsite"
    },
    {
        id: 35,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: "offsite-image-3.jpg",
        title: "vahak-offsite"
    },
    {
        id: 36,
        widthLarge: 500,
        widthSmall: 263,
        imageurlLarge: "offsite-image-4.jpg",
        title: "vahak-offsite"
    },
    {
        id: 37,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: "offsite-image-6.jpg",
        title: "vahak-offsite"
    },
    {
        id: 38,
        widthLarge: 500,
        widthSmall: 263,
        imageurlLarge: "badminton-tournament.JPG",
        title: "vahak-badminton-tournament"
    },
    {
        id: 39,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: "offsite-image-8.jpg",
        title: "vahak-offsite"
    },
    {
        id: 40,
        widthLarge: 240,
        widthSmall: 335,
        imageurlLarge: "vahak-womensgroup.jpg",
        title: "vahak-girls"
    },
    {
        id: 41,
        widthLarge: 400,
        widthSmall: 260,
        imageurlLarge: "birthdayboysgirls.jpg",
        title: "vahak-birthda-party"
    },
    {
        id: 42,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: "ethnic-dressing-1.JPG",
        title: "vahak-ethnic"
    },
    {
        id: 43,
        widthLarge: 500,
        widthSmall: 263,
        imageurlLarge: "ethnic-dressing-4.JPG",
        title: "vahak-ethnic"
    },
    {
        id: 45,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: "ethnic-dressing-3.JPG",
        title: "vahak-ethnic"
    },
    {
        id: 46,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: "ethnic-dressing-2.JPG",
        title: "vahak-ethnic"
    },
    {
        id: 47,
        widthLarge: 332,
        widthSmall: 263,
        imageurlLarge: "offsite-image-7.jpg",
        title: "vahak-offsite"
    },
    {
        id: 48,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: "ethnic-dressing-5.JPG",
        title: "vahak-ethnic"
    },
    {
        id: 49,
        widthLarge: 340,
        widthSmall: 263,
        imageurlLarge: "photoshoot-4.JPG",
        title: "vahak-photoshoot"
    },
    {
        id: 50,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: "photoshoot-10.jpg",
        title: "vahak-photoshoot"
    },
    {
        id: 51,
        widthLarge: 330,
        widthSmall: 263,
        imageurlLarge: "photoshoot-14.JPG",
        title: "vahak-photoshoot"
    },
    {
        id: 52,
        widthLarge: 500,
        widthSmall: 263,
        imageurlLarge: "photoshoot-15.JPG",
        title: "vahak-photoshoot"
    },
    {
        id: 53,
        widthLarge: 300,
        widthSmall: 263,
        imageurlLarge: "photoshoot-9.JPG",
        title: "vahak-photoshoot"
    },
    {
        id: 54,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: "photoshoot-8.JPG",
        title: "vahak-photoshoot"
    },
    {
        id: 55,
        widthLarge: 600,
        widthSmall: 263,
        imageurlLarge: "photoshoot-3.JPG",
        title: "vahak-photoshoot"
    },
    {
        id: 56,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: "photoshoot-12.JPG",
        title: "vahak-photoshoot"
    },
    {
        id: 57,
        widthLarge: 600,
        widthSmall: 263,
        imageurlLarge: "photoshoot-2.JPG",
        title: "vahak-photoshoot"
    },
    {
        id: 58,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: "photoshoot-1.JPG",
        title: "vahak-photoshoot"
    },
    {
        id: 59,
        widthLarge: 500,
        widthSmall: 263,
        imageurlLarge: "photoshoot-11.JPG",
        title: "vahak-photoshoot"
    },
    {
        id: 60,
        widthLarge: 600,
        widthSmall: 263,
        imageurlLarge: "join-our-fam.JPG",
        title: "vahak-photoshoot"
    },
    {
        id: 61,
        widthLarge: 400,
        widthSmall: 263,
        imageurlLarge: "photoshoot-13.JPG",
        title: "vahak-photoshoot"
    }
];
vahakLifeImages.reverse();
var _vahakLifeImages1 = vahakLifeImages.slice(0, vahakLifeImages.length / 2);
var _vahakLifeImages2 = vahakLifeImages.slice(vahakLifeImages.length / 2);
var vahakLifeImages1 = [];
var vahakLifeImages2 = [];
Array(8).fill(undefined).forEach(function() {
    var _vahakLifeImages11, _vahakLifeImages21;
    (_vahakLifeImages11 = vahakLifeImages1).push.apply(_vahakLifeImages11, (0,_to_consumable_array/* default */.Z)(_vahakLifeImages1));
    (_vahakLifeImages21 = vahakLifeImages2).push.apply(_vahakLifeImages21, (0,_to_consumable_array/* default */.Z)(_vahakLifeImages2));
});
var LifeatVahak = function() {
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LifeatVahak_module_default()).lifeAtVahakRow,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    children: [
                        "Behind the",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "data-hover": "Wheel at Vahak",
                            className: isMobile ? "" : "indaiText",
                            children: "Wheel at Vahak"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer/* default */.Z, {
                containerClass: (LifeatVahak_module_default()).scrollableContainer,
                length: vahakLifeImages1 === null || vahakLifeImages1 === void 0 ? void 0 : vahakLifeImages1.length,
                scrollBy: 3,
                autoScroll: "SCROLL_RL",
                isNavShadow: false,
                showNavArrows: false,
                items: vahakLifeImages1.map(function(vahaklifeImage, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lifeat_vahak_image_LifeatVahakImage, {
                        lifeatVahakImg: vahaklifeImage
                    }, String(i));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer/* default */.Z, {
                containerClass: (LifeatVahak_module_default()).scrollableContainer,
                length: vahakLifeImages2 === null || vahakLifeImages2 === void 0 ? void 0 : vahakLifeImages2.length,
                scrollBy: 3,
                autoScroll: "SCROLL_LR",
                isNavShadow: false,
                showNavArrows: false,
                items: vahakLifeImages2.map(function(vahaklifeImage, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lifeat_vahak_image_LifeatVahakImage, {
                        lifeatVahakImg: vahaklifeImage
                    }, String(i));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var lifeat_vahak_LifeatVahak = (LifeatVahak);

// EXTERNAL MODULE: ./components/careers/stories/Stories.module.scss
var Stories_module = __webpack_require__(40543);
var Stories_module_default = /*#__PURE__*/__webpack_require__.n(Stories_module);
;// CONCATENATED MODULE: ../core/dist/icons/StoryColon.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgStoryColon(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.2,
    height: 28.2,
    viewBox: "0 0 39.2 28.2"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    "data-name": "Path 121051",
    d: "M8.7 28.2a8.381 8.381 0 01-6.15-2.55A8.381 8.381 0 010 19.5a8.427 8.427 0 01.6-3.25 19.043 19.043 0 011.9-3.35L11.2 0l5.9 3.9-5.1 7.8a8.446 8.446 0 013.8 2.95 7.989 7.989 0 011.5 4.85 8.466 8.466 0 01-2.5 6.15 8.218 8.218 0 01-6.1 2.55zm21.9 0a8.381 8.381 0 01-6.15-2.55 8.381 8.381 0 01-2.55-6.15 8.427 8.427 0 01.6-3.25 19.043 19.043 0 011.9-3.35L33.1 0 39 3.9l-5.1 7.8a8.446 8.446 0 013.8 2.95 7.989 7.989 0 011.5 4.85 8.466 8.466 0 01-2.5 6.15 8.218 8.218 0 01-6.1 2.55z",
    fill: "#0c7eff",
    opacity: 0.2
  })));
}

/* harmony default export */ var StoryColon = (SvgStoryColon);
// EXTERNAL MODULE: ./components/careers/stories/story/Story.module.scss
var Story_module = __webpack_require__(75150);
var Story_module_default = /*#__PURE__*/__webpack_require__.n(Story_module);
;// CONCATENATED MODULE: ./components/careers/stories/story/Story.tsx






var Story = function(param) {
    var imgSrcLarge = param.imgSrcLarge, author = param.author, authorPosition = param.authorPosition, text = param.text;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Story_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Story_module_default()).imgBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                    src: "".concat(imgSrcLarge),
                    alt: author + ", " + authorPosition + ", Vahak",
                    layout: "responsive",
                    width: isMobile ? "267" : "410",
                    height: isMobile ? "231" : "356"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Story_module_default()).textBox,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Story_module_default()).colonImg,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoryColon, {
                            width: "39.2",
                            height: "28.2"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Story_module_default()).author,
                        children: author
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Story_module_default()).authorPosition,
                        children: authorPosition
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var story_Story = (Story);

// EXTERNAL MODULE: ../core/dist/components/custom-carousel/CustomCarousel.js + 1 modules
var CustomCarousel = __webpack_require__(25531);
;// CONCATENATED MODULE: ./components/careers/stories/Stories.tsx







var items = [
    {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(story_Story, {
            text: "At Vahak, you will find healthy chaos that everyone wants to be a part of! There are enough challenges for everyone at every level.",
            imgSrcLarge: "Punit-desktop.png",
            author: "Punit Chotia",
            authorPosition: "Marketing Growth Head"
        }),
        key: "1"
    },
    {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(story_Story, {
            text: "Life at Vahak is the total package! Career growth, work environment, team spirit, employee wellness..we have it all! I actually enjoy coming to work on Mondays.",
            imgSrcLarge: "akshathaempt.png",
            author: "Akshatha R",
            authorPosition: "SDE (QA)"
        }),
        key: "2"
    },
    {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(story_Story, {
            text: "Here you will find diverse people which make a good competitive peer group that pushes your limits. Truly love the learning experience here ; great leadership who believes in YOU.",
            imgSrcLarge: "varshapempt.png",
            author: "Varshap W",
            authorPosition: "Backend Engineer"
        }),
        key: "3"
    },
    {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(story_Story, {
            text: "The perfect mix of liveliness and sincerity at Vahak create the ideal environment for me to work!",
            imgSrcLarge: "Ayaz-Desktop.png",
            author: "Ayaz Siddiqui",
            authorPosition: "SDET"
        }),
        key: "4"
    },
    {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(story_Story, {
            text: "Working at Vahak is a healthy mix of engaging in interesting conversations with colleagues and taking up challenging tasks!",
            imgSrcLarge: "Ram_Story-desktop.png",
            author: "Rammurthy",
            authorPosition: "Data Scientist"
        }),
        key: "5"
    },
    {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(story_Story, {
            text: "For me, this is more than a job. I’m investing my time, my knowledge and experience in a company that is investing in me",
            imgSrcLarge: "tanushreel.jpg",
            author: "Tanushree L",
            authorPosition: "Social Media Head"
        }),
        key: "6"
    },
    {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(story_Story, {
            text: "The work environment is very friendly, team-oriented and laser-focused to change the landscape of Indian logistics.",
            imgSrcLarge: "roja-k.JPG",
            author: "Roja K",
            authorPosition: "Digital Marketing Manager"
        }),
        key: "7"
    },
    {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(story_Story, {
            text: "Vahak is a fast-growing company and a wonderful place to work!",
            imgSrcLarge: "abhay--k.jpg",
            author: "Abhay K",
            authorPosition: "Customer Service Executive"
        }),
        key: "8"
    },
    {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(story_Story, {
            text: "The company treats you like a valued person, not just an employee. There is a lot of scope to experiment making it very creatively fulfilling",
            imgSrcLarge: "rajatempt.png",
            author: "Rajat S",
            authorPosition: "National Head, offline sales and marketing"
        }),
        key: "9"
    }
];
var Stories = function() {
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Stories_module_default()).wrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                children: [
                    "What",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        "data-hover": "Our Crew",
                        className: isMobile ? "" : "indaiText",
                        children: "Our Crew"
                    }),
                    " ",
                    "is saying"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Stories_module_default()).storiesOuterWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCarousel/* default */.Z, {
                    containerClass: (Stories_module_default()).carouselContainer,
                    rowClass: (Stories_module_default()).carouselRow,
                    itemClass: (Stories_module_default()).carouselItem,
                    activeClass: (Stories_module_default()).carouselActive,
                    prevNextBtnsClass: (Stories_module_default()).buttonsClass,
                    dotsClass: (Stories_module_default()).carouselDots,
                    length: items === null || items === void 0 ? void 0 : items.length,
                    scrollBy: 1,
                    items: items === null || items === void 0 ? void 0 : items.map(function(data, index) {
                        return data.children;
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var stories_Stories = (Stories);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/careers/explore-jobs/ExploreJobs.module.scss
var ExploreJobs_module = __webpack_require__(54217);
var ExploreJobs_module_default = /*#__PURE__*/__webpack_require__.n(ExploreJobs_module);
// EXTERNAL MODULE: ./components/careers/explore-jobs/job-card/JobCard.module.scss
var JobCard_module = __webpack_require__(89174);
var JobCard_module_default = /*#__PURE__*/__webpack_require__.n(JobCard_module);
// EXTERNAL MODULE: ./components/careers/util-methods.ts
var util_methods = __webpack_require__(34113);
// EXTERNAL MODULE: ../../node_modules/react-loading-skeleton/lib/index.js
var lib = __webpack_require__(51992);
;// CONCATENATED MODULE: ./components/careers/explore-jobs/job-card/JobCard.tsx






var JobCard = function(param) {
    var jobDetails = param.jobDetails, isLoading = param.isLoading;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    var ref = (0,react.useState)(), parsedDetails = ref[0], setParsedDetails = ref[1];
    (0,react.useEffect)(function() {
        if (jobDetails) {
            setParsedDetails((0,util_methods/* getJobMetaInfo */.v)(jobDetails === null || jobDetails === void 0 ? void 0 : jobDetails.custom_excerpt));
        }
    }, [
        jobDetails
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (JobCard_module_default()).jobCardCol,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (JobCard_module_default()).jobCard,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            jobDetails === null || jobDetails === void 0 ? void 0 : jobDetails.title,
                            " (",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    " ",
                                    parsedDetails === null || parsedDetails === void 0 ? void 0 : parsedDetails.experience,
                                    " "
                                ]
                            }),
                            ")"
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                        width: isMobile ? "60vw" : "360px"
                    })
                }),
                !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: parsedDetails === null || parsedDetails === void 0 ? void 0 : parsedDetails.qualification
                        }),
                        " . ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                parsedDetails === null || parsedDetails === void 0 ? void 0 : parsedDetails.type,
                                ", Bangalore"
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                    width: isMobile ? "75vw" : "420px"
                })
            ]
        })
    });
};
/* harmony default export */ var job_card_JobCard = (JobCard);

// EXTERNAL MODULE: ../core/dist/_services/careers.service.js
var careers_service = __webpack_require__(66727);
// EXTERNAL MODULE: ../core/dist/components/app-anchor/A.js
var A = __webpack_require__(70561);
// EXTERNAL MODULE: ../core/dist/methods/sleep.js
var sleep = __webpack_require__(37007);
// EXTERNAL MODULE: ../core/dist/icons/ArrowDownBlue.svg
var ArrowDownBlue = __webpack_require__(636);
// EXTERNAL MODULE: ../core/dist/components/quick-filter-pill/QuickFilterPill.js + 1 modules
var QuickFilterPill = __webpack_require__(46168);
;// CONCATENATED MODULE: ./components/careers/explore-jobs/ExploreJobs.tsx

















var MAX_JOBS_PER_PAGE = 6;
var AllCateg = {
    name: "All Jobs",
    slug: "all"
};
var AllCategMobile = {
    name: "All Job Openings",
    slug: "all"
};
var ExploreJobs = function(param) {
    var jobsData = param.jobsData, meta = param.meta, categories = param.categories;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    /***
     * states
     */ var ref = (0,react.useState)([
        isMobile ? AllCategMobile : AllCateg
    ].concat((0,_to_consumable_array/* default */.Z)(categories || []))), categs = ref[0], setCategs = ref[1];
    var ref1 = (0,react.useState)(isMobile ? AllCategMobile : AllCateg), selectedCateg = ref1[0], setSelectedCateg = ref1[1];
    var ref2 = (0,react.useState)(jobsData), jobs = ref2[0], setJobs = ref2[1];
    var ref3 = (0,react.useState)((meta === null || meta === void 0 ? void 0 : meta.pagination.total) || 0), totalJobs = ref3[0], setTotalJobs = ref3[1];
    var ref4 = (0,react.useState)(1), page = ref4[0], setPage = ref4[1];
    var ref5 = (0,react.useState)((meta === null || meta === void 0 ? void 0 : meta.pagination.pages) || 1), totalPages = ref5[0], setTotalsPages = ref5[1];
    var ref6 = (0,react.useState)(false), isLoading = ref6[0], setIsLoading = ref6[1];
    var onClickShowMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var t1, ref, jobs, meta, ref1, jobs1, meta1, t2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        t1 = Date.now();
                        setPage(function(state) {
                            return state + 1;
                        });
                        // getAndSetData({ page: page + 1, categ: selectedCateg });
                        setIsLoading(true);
                        if (!selectedCateg.slug.includes("all")) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 6;
                        return careers_service/* CareersService.getAllJobs */.l.getAllJobs({
                            page: page + 1,
                            limit: MAX_JOBS_PER_PAGE
                        });
                    case 6:
                        ref = _ctx.sent;
                        jobs = ref.jobs;
                        meta = ref.meta;
                        setJobs(function(state) {
                            return (0,_to_consumable_array/* default */.Z)(state || []).concat((0,_to_consumable_array/* default */.Z)(jobs || []));
                        });
                        setTotalsPages((meta === null || meta === void 0 ? void 0 : meta.pagination.pages) || 1);
                        setTotalJobs((meta === null || meta === void 0 ? void 0 : meta.pagination.total) || 0);
                        _ctx.next = 22;
                        break;
                    case 14:
                        _ctx.next = 16;
                        return careers_service/* CareersService.getJobsByCateg */.l.getJobsByCateg({
                            page: page + 1,
                            limit: MAX_JOBS_PER_PAGE,
                            categSlug: selectedCateg.slug
                        });
                    case 16:
                        ref1 = _ctx.sent;
                        jobs1 = ref1.jobs;
                        meta1 = ref1.meta;
                        setJobs(function(state) {
                            return (0,_to_consumable_array/* default */.Z)(state || []).concat((0,_to_consumable_array/* default */.Z)(jobs1 || []));
                        });
                        setTotalsPages((meta1 === null || meta1 === void 0 ? void 0 : meta1.pagination.pages) || 1);
                        setTotalJobs((meta1 === null || meta1 === void 0 ? void 0 : meta1.pagination.total) || 0);
                    case 22:
                        t2 = Date.now();
                        if (!(t2 - t2 < 500)) {
                            _ctx.next = 26;
                            break;
                        }
                        _ctx.next = 26;
                        return (0,sleep/* sleep */._)(500 - (t2 - t1));
                    case 26:
                        setIsLoading(false);
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickShowMore() {
            return _ref.apply(this, arguments);
        };
    }();
    // useEffect(() => {
    //     isLoading && setJobs(getEmptyArray(jobs?.length || 0));
    // }, [isLoading]);
    var handleOnSelectCategory = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cateSlug) {
            var ref, jobs, meta, ref1, jobs1, meta1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSelectedCateg(categs.find(function(c) {
                            return c.slug === cateSlug;
                        }) || AllCategMobile);
                        if (!(cateSlug === "all")) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 4;
                        return careers_service/* CareersService.getAllJobs */.l.getAllJobs({
                            page: page,
                            limit: MAX_JOBS_PER_PAGE
                        });
                    case 4:
                        ref = _ctx.sent;
                        jobs = ref.jobs;
                        meta = ref.meta;
                        setJobs(jobs);
                        setTotalsPages((meta === null || meta === void 0 ? void 0 : meta.pagination.pages) || 1);
                        setTotalJobs((meta === null || meta === void 0 ? void 0 : meta.pagination.total) || 0);
                        _ctx.next = 20;
                        break;
                    case 12:
                        _ctx.next = 14;
                        return careers_service/* CareersService.getJobsByCateg */.l.getJobsByCateg({
                            page: 1,
                            limit: MAX_JOBS_PER_PAGE,
                            categSlug: cateSlug
                        });
                    case 14:
                        ref1 = _ctx.sent;
                        jobs1 = ref1.jobs;
                        meta1 = ref1.meta;
                        setJobs(jobs1);
                        setTotalsPages((meta1 === null || meta1 === void 0 ? void 0 : meta1.pagination.pages) || 1);
                        setTotalJobs((meta1 === null || meta1 === void 0 ? void 0 : meta1.pagination.total) || 0);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOnSelectCategory(cateSlug) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ExploreJobs_module_default()).explorejobsHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "Open Positions"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ExploreJobs_module_default()).categoryButtonsWrap,
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ExploreJobs_module_default()).jobDropDownBox,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            onChange: function(e) {
                                var ref;
                                e.persist();
                                handleOnSelectCategory(((ref = categs.find(function(c) {
                                    return c.slug === e.target.value;
                                })) === null || ref === void 0 ? void 0 : ref.slug) || AllCategMobile);
                            },
                            children: categs.map(function(param) {
                                var name = param.name, slug = param.slug;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: slug,
                                    children: name
                                }, slug);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (ExploreJobs_module_default()).iconDownArow,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownBlue/* default */.Z, {})
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* default */.Z, {
                    children: categs.map(function(param) {
                        var name = param.name, slug = param.slug;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickFilterPill/* default */.Z, {
                            className: (ExploreJobs_module_default()).categoryButton,
                            text: name,
                            data: {
                                name: name,
                                slug: slug
                            },
                            isSelected: selectedCateg.slug === slug,
                            selectedClassName: (ExploreJobs_module_default()).selectedCateg,
                            onSelected: function() {
                                return handleOnSelectCategory(slug);
                            }
                        }, slug);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ExploreJobs_module_default()).jobCardWrap,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: jobs && (jobs === null || jobs === void 0 ? void 0 : jobs.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Showing ",
                                selectedCateg.slug === "all" ? "All" : selectedCateg.name,
                                " jobs (",
                                totalJobs,
                                ")"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* default */.Z, {
                        children: jobs === null || jobs === void 0 ? void 0 : jobs.map(function(job, i) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
                                href: "/careers/".concat(job === null || job === void 0 ? void 0 : job.slug),
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    style: {
                                        margin: isMobile ? "7px 0" : "15px 0",
                                        padding: isMobile ? "0" : "0 15px",
                                        width: isMobile ? "100%" : "50%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(job_card_JobCard, {
                                        jobDetails: job,
                                        isLoading: isLoading && i + 1 > (page - 1) * MAX_JOBS_PER_PAGE
                                    })
                                })
                            }, (job === null || job === void 0 ? void 0 : job.slug) || i);
                        })
                    }),
                    page < totalPages && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((ExploreJobs_module_default()).showMore),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                            onClick: onClickShowMore,
                            children: "Show more"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ExploreJobs_module_default()).couldntFindMatch,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ExploreJobs_module_default()).findMatchRow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: "Can’t find your fit? Drop your CV and we’ll reach out when an opportunity comes up!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                            href: "https://docs.google.com/forms/d/e/1FAIpQLSdIv1JUon9yquV5zVAwgJ4PoCAibeJtxSVWNNrQ4qlDP0dfxQ/viewform?usp=sf_link",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBtn/* default */.Z, {
                                disabled: false,
                                className: (ExploreJobs_module_default()).sendYourCV,
                                type: "primary",
                                btnType: "submit",
                                style: {
                                    backgroundColor: "#FFFFFF",
                                    color: "#08123B",
                                    textAlign: "center",
                                    fontSize: isMobile ? "14px" : "20px",
                                    padding: isMobile ? "10px" : "15px",
                                    height: isMobile ? "46px" : "64px",
                                    width: isMobile ? "180px" : "254px",
                                    display: "block",
                                    marginTop: "10px",
                                    marginBottom: "20px",
                                    marginLeft: isMobile ? "0" : "auto",
                                    marginRight: isMobile ? "auto" : "0",
                                    lineHeight: "25px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Drop your CV"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var explore_jobs_ExploreJobs = (ExploreJobs);

// EXTERNAL MODULE: ./components/careers/located/Located.tsx
var Located = __webpack_require__(84445);
// EXTERNAL MODULE: ./components/careers/Careers.module.scss
var Careers_module = __webpack_require__(38079);
var Careers_module_default = /*#__PURE__*/__webpack_require__.n(Careers_module);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
;// CONCATENATED MODULE: ./components/careers/Careers.tsx














var Careers = function(param) {
    var jobs = param.jobs, meta = param.meta, categs = param.categs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaTags/* default */.Z, {
                title: "Vahak - Careers",
                description: "Vahak helps Logistic companies to connect with Truck Owners, Brokers, and other Transporters from All India. A Branding & Networking tool for Indian Transport Industry. The online brand coupled with the huge network creates wonderful opportunities especially for small and medium scale transport businesses to grow.",
                canonicalUrl: "https://www.vahak.in/careers",
                ogUrl: "https://www.vahak.in/careers",
                ogImgAltText: "Book Trucks, Containers from Thousands of Trusted Transport businesses and Lorry Owners from All India",
                schemaOrgJsonUrl: "/careers",
                includeDefaultSchema: false,
                schemaType: "WebPage"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Careers_module_default()).careersPageWrap,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        id: "welcome",
                        className: classnames_default()((Careers_module_default()).welcomeSection, (Careers_module_default()).sections, "flipAnimate"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(welcome_Welcome, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        id: "values",
                        className: classnames_default()((Careers_module_default()).ourValueSection, (Careers_module_default()).sections, "flipAnimate"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(our_values_OurValues, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        id: "benefits",
                        className: classnames_default()((Careers_module_default()).benefitsSection, (Careers_module_default()).sections, "flipAnimate"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Benefits/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: classnames_default()((Careers_module_default()).jd),
                                children: [
                                    "To know more about us, our culture and what’s in store for you",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                        openInNewTab: true,
                                        href: misc/* IMG_BASE_URL */.TS + "/1JD.pdf",
                                        children: "click here"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        id: "life",
                        className: classnames_default()((Careers_module_default()).lifeatVahakSection, (Careers_module_default()).sections, "flipAnimate"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lifeat_vahak_LifeatVahak, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        id: "stories",
                        className: classnames_default()((Careers_module_default()).storiesSection, (Careers_module_default()).sections, "flipAnimate", "container"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stories_Stories, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        id: "jobs",
                        className: classnames_default()((Careers_module_default()).exploreJobSection, (Careers_module_default()).sections, "flipAnimate"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(explore_jobs_ExploreJobs, {
                                jobsData: jobs,
                                meta: meta,
                                categories: categs
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        id: "location",
                        className: classnames_default()((Careers_module_default()).locationSection, (Careers_module_default()).sections, "flipAnimate"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Located/* default */.Z, {})
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var careers_Careers = (Careers);


/***/ }),

/***/ 84445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Located_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80893);
/* harmony import */ var _Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Located_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4628);
/* harmony import */ var _vahak_core_dist_components_app_anchor_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70561);
/* harmony import */ var _vahak_core_dist_components_app_btn_AppBtn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49995);
/* harmony import */ var _vahak_core_dist_constants_companyDetails__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51061);







var Located = function() {
    var isMobile = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().heading),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    children: [
                        "We’re located at the",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            "data-hover": "heart of Bangalore",
                            className: isMobile ? "" : "indaiText",
                            children: "heart of Bangalore"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().locatedRow),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().locatedMapCol),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                            src: _vahak_core_dist_constants_companyDetails__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_DETAILS.googleMapEmbedLink */ .S.googleMapEmbedLink,
                            width: "460",
                            style: {
                                border: "0px",
                                width: "100%",
                                borderRadius: "15px",
                                height: isMobile ? "200px" : "415px"
                            },
                            loading: "lazy",
                            title: "Vahak Office Map"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().locatedAddressCol),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().addressBox),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().row),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().col),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                children: _vahak_core_dist_constants_companyDetails__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_DETAILS.workspace */ .S.workspace
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().col),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: _vahak_core_dist_constants_companyDetails__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_DETAILS.address */ .S.address
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_components_app_anchor_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    openInNewTab: true,
                                    href: _vahak_core_dist_constants_companyDetails__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_DETAILS.googleMapLink */ .S.googleMapLink,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_components_app_btn_AppBtn__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().viewMapButton),
                                        children: "View on Maps"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Located);


/***/ }),

/***/ 54217:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"explorejobsHeader":"ExploreJobs_explorejobsHeader___LdbC","categoryButton":"ExploreJobs_categoryButton__R92qm","selectedCateg":"ExploreJobs_selectedCateg__gZ7Lb","jobCardWrap":"ExploreJobs_jobCardWrap__MAKKJ","showMore":"ExploreJobs_showMore__Ghr4f","couldntFindMatch":"ExploreJobs_couldntFindMatch__94q1p","findMatchRow":"ExploreJobs_findMatchRow__X3743","jobDropDownBox":"ExploreJobs_jobDropDownBox__x4hn_","iconDownArow":"ExploreJobs_iconDownArow__eLwMC","categoryButtonsWrap":"ExploreJobs_categoryButtonsWrap____36O"};

/***/ }),

/***/ 89174:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobCardCol":"JobCard_jobCardCol__lJDzu","jobCard":"JobCard_jobCard__0_VLi"};

/***/ }),

/***/ 22010:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lifeAtVahakRow":"LifeatVahak_lifeAtVahakRow__8PZCV"};

/***/ }),

/***/ 2060:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slideItem":"LifeatVahakImage_slideItem__YEYkb"};

/***/ }),

/***/ 80893:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"Located_heading__E6e0y","locatedRow":"Located_locatedRow__rHFgE","locatedMapCol":"Located_locatedMapCol__KpAEN","addressBox":"Located_addressBox__5afdP","row":"Located_row__htoTF","col":"Located_col__fMcXp","viewMapButton":"Located_viewMapButton__WKIEf","locatedAddressCol":"Located_locatedAddressCol__HwUS0"};

/***/ }),

/***/ 56706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ourValuesHeading":"OurValues_ourValuesHeading__WncRp","valuesRow":"OurValues_valuesRow__qMAuw","valuesCard":"OurValues_valuesCard__JGNi1","textBox":"OurValues_textBox__9vXfn"};

/***/ }),

/***/ 40543:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Stories_wrapper__rox1_","carouselDots":"Stories_carouselDots__8BKtS","storiesOuterWrapper":"Stories_storiesOuterWrapper__qEmMb"};

/***/ }),

/***/ 75150:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Story_wrapper__D6SzX","imgBox":"Story_imgBox__WY3xZ","textBox":"Story_textBox__q89DG","colonImg":"Story_colonImg__eCozd","author":"Story_author__JRSJd","authorPosition":"Story_authorPosition__XB2ei"};

/***/ }),

/***/ 69984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"row":"Welcome_row__MMrUh","textCol":"Welcome_textCol__wzJZ4","openPositionBtn":"Welcome_openPositionBtn__Gam1I","imgCol":"Welcome_imgCol__VSpIV","imgboxRow":"Welcome_imgboxRow__G_Hh_","imgbox":"Welcome_imgbox__WGH6M","gridSlideTTB":"Welcome_gridSlideTTB__DdYfD","gridSlideRTL":"Welcome_gridSlideRTL__aXdGP","gridSlideLTR":"Welcome_gridSlideLTR__yqweK","gridSlideBTT":"Welcome_gridSlideBTT__FZBei","indiaTextWrap":"Welcome_indiaTextWrap__YmA84","ourVision":"Welcome_ourVision__rF_U_"};

/***/ })

}]);